import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-rate@2.3.0@rc-rate/es/index.js
// module id = 629
// module chunks = 0